import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useProyecto } from '../../../data/ProyectoContext';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const AdaptacionesCurriculares = () => {

    const { proyecto, setProyecto } = useProyecto();
    const {promptData, setPromptData} = useActividadesContext();

    const adaptaciones_curricularesValue = promptData.adaptaciones_curriculares ?? '';

    const handleCharacterizationProyectChange = (event) => {
        const { value } = event.target;
        setProyecto({...proyecto, adaptaciones_curriculares: value
        });
        setPromptData((prevData) => ({
            ...prevData,
            adaptaciones_curriculares: value 
          }));
      };

    
    return (
        <Grid xs={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} > Adaptaciones curriculares </Typography>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>Detalla las necesidades educativas y características específicas de estudiantes que requieran ajustes y apoyos específicos que deben ser consideradas</FormLabel>
            <TextField
                required
                id="contexto"
                placeholder='Escribe aquí los ajustes y apoyos requeridos. Ejemplo: Una estudiante con dislexia'
                name="contexto"
                fullWidth
                autoComplete="given-name"
                variant="outlined"
                value={adaptaciones_curricularesValue}
                onChange={handleCharacterizationProyectChange}
                InputProps={{
                    sx: {
                        borderRadius:2,
                        mt:1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                      color: '#336B87',
                        '&::placeholder': {
                          color: '#336B87',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

export default AdaptacionesCurriculares;




